const ar = {
  ChargePointLogListItem: {
    callID: 'رقم الهوية',
  },
}
export default ar
